import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export type NavMode = "business" | "admin";

interface NavModeContextValue {
  mode: NavMode;
  setMode: (mode: NavMode) => void;
}

const NavModeContext = createContext<NavModeContextValue>({ mode: "business", setMode: () => {} });

export const NavModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setModeState] = useState<NavMode>(() => {
    try {
      const stored = localStorage.getItem("nav-mode");
      return (stored as NavMode) || "business";
    } catch {
      return "business";
    }
  });

  const setMode = (m: NavMode) => {
    setModeState(m);
    try {
      localStorage.setItem("nav-mode", m);
    } catch {
      // storage unavailable (e.g. sandboxed/embedded contexts)
    }
  };

  const value = useMemo(() => ({ mode, setMode }), [mode]);
  return <NavModeContext.Provider value={value}>{children}</NavModeContext.Provider>;
};

export const useNavMode = () => useContext(NavModeContext);
